"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const blockFilterState_1 = __importDefault(require("@/common/components/NavHeader/blockFilterState"));
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const detect_utils_1 = require("@/common/detect_utils");
const functions_1 = require("@/common/functions");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const _1 = require(".");
function default_1() {
    const { ready: isBlockFilterReady, blockFilter } = (0, recoil_1.useRecoilValue)(blockFilterState_1.default);
    const isBlockFilterAvailable = !!blockFilter;
    const [hotCommissionData, setHotCommissionData] = (0, react_1.useState)([]);
    const isDataAvailable = !!hotCommissionData.length;
    const { setScrollDiv } = (0, functions_1.useHorizontalDragScroll)();
    const dataSize = 5;
    (0, react_1.useEffect)(() => {
        if (isBlockFilterReady && !isDataAvailable) {
            (0, api_1.getData)(`${detect_utils_1.fondeeSearchOrigin}/api/v1/fondee/room?type=hot-commission&size=${dataSize}${isBlockFilterAvailable ? `&filter=${blockFilter}` : ''}`)
                .then(res => setHotCommissionData(res.data))
                .catch(() => { });
        }
    }, [isBlockFilterReady]);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const maxWidth1024 = (0, useMediaQuery_1.default)('(max-width:1024px)');
    const { t } = (0, react_i18next_1.useTranslation)();
    const initialSkeletonArr = new Array(dataSize).fill('skeleton');
    if (maxWidth768)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
            display: 'flex',
            flexDirection: 'column',
        } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle2 gray-80", css: { padding: maxWidth768 ? '0 11px' : maxWidth1024 ? '0 11px 0 0' : 0 } }, { children: t('지금, 커미션은 어때요?') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ ref: setScrollDiv, className: maxWidth768 ? 'horizontal_drag_scroll no_scroll_bar' : undefined, css: {
                    display: 'flex',
                    flexDirection: maxWidth768 ? 'row' : 'column',
                    gap: '10px',
                    padding: maxWidth768 ? '15px 11px 0' : maxWidth1024 ? '20px 11px 0 0' : '20px 0 0',
                } }, { children: isDataAvailable
                    ? hotCommissionData.map((roomData, index) => ((0, jsx_runtime_1.jsx)(_1.HotCommissionCard, { roomData: roomData, maxWidth768: maxWidth768 }, `hot_commission_${index}`)))
                    : initialSkeletonArr.map((_, index) => ((0, jsx_runtime_1.jsx)(_1.HotCommissionCardSkeleton, { maxWidth768: maxWidth768 }, `hot_commission_skeleton_${index}`))) }))] })));
}
exports.default = default_1;
